import React, { useContext, useEffect, MouseEvent } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import Button from '@carvana/showroom-forms/Button/Primary';
import { LinkWithNativeEvents, OpenInNewTabWithNativeEvents } from '../../../../../components/_common/link/link';

import { datadogRum } from '@datadog/browser-rum';
import { Row, TextBox, ButtonRow, NumberedList } from './style';
import { Link } from '../../styles';
import { ModalContentWrapper } from '../../../ASRCard.styles';
import { AsrAnalytics } from '../../../../../constants';

const MechanicalSubmission = () => {
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    trackEvent(AsrAnalytics.MECH_VIEWED_SUCCESS);
    datadogRum.addAction(AsrAnalytics.MECH_VIEWED_SUCCESS);
  }, []);

  const sendEventAndGo = (e: MouseEvent<HTMLAnchorElement>, event: string, urlData: string[]) => {
    e.preventDefault();
    trackEvent(event);
    window.open(...urlData);
  };

  return (
    <ModalContentWrapper>
      <Row>
        <TextBox bold>
          Good news, most concerns are covered under your 100 day limited warranty! Mechanical and electrical concerns
          do require a professional diagnosis. There are three simple steps to getting your concern repaired:
        </TextBox>
        <TextBox grey>
          <NumberedList>
            <li>
              Visit{' '}
              <LinkWithNativeEvents
                href="/repairs"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  trackEvent(AsrAnalytics.MECH_SUCCESS_CLICKED_REPAIRS);
                }}
                nativeEvent={{
                  event: 'link',
                  payload: { url: '/repairs' },
                }}
              >
                www.carvana.com/repairs
              </LinkWithNativeEvents>{' '}
              to locate a Preferred Repair Facility
            </li>
            <li>
              Schedule an appointment with the repair facility and inform them you have a warranty with SilverRock
            </li>
            <li>
              Have the repair facility call SilverRock at{' '}
              <LinkWithNativeEvents
                href="tel:877-584-3848"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  trackEvent(AsrAnalytics.MECH_SUCCESS_CALL_SILVERROCK_DIAGNOSTIC);
                }}
                nativeEvent={{
                  event: 'link',
                  payload: {
                    url: 'tel:877-584-3848',
                  },
                }}
              >
                877-584-3848
              </LinkWithNativeEvents>{' '}
              to review the completed diagnostic
            </li>
          </NumberedList>
        </TextBox>
        <TextBox grey>
          If a repair is needed and authorized, the Repair Facility will work with you to schedule a time to complete
          the repairs.
        </TextBox>
        <TextBox grey>
          If you have any questions about the process or coverage, you can text SilverRock at{' '}
          <LinkWithNativeEvents
            href="sms:833-394-8239"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              trackEvent(AsrAnalytics.MECH_SUCCESS_TEXT_SILVERROCK);
            }}
            nativeEvent={{
              event: 'sms',
              payload: { phoneNumber: '833-394-8239' },
            }}
          >
            833-394-8239
          </LinkWithNativeEvents>{' '}
          or call at{' '}
          <LinkWithNativeEvents
            href="tel:866-628-3905"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              trackEvent(AsrAnalytics.MECH_SUCCESS_CALL_SILVERROCK_QUESTIONS);
            }}
            nativeEvent={{
              event: 'link',
              payload: {
                url: 'tel:866-628-3905',
              },
            }}
          >
            866-628-3905.
          </LinkWithNativeEvents>
        </TextBox>
      </Row>
      <ButtonRow>
        <Button
          style={{ width: '100%' }}
          onClick={() => {
            trackEvent(AsrAnalytics.CLICKED_FIND_REPAIR_FACILITY);
            OpenInNewTabWithNativeEvents({
              url: 'https://www.yourvehiclecare.com',
              event: 'link',
              payload: { url: 'https://www.yourvehiclecare.com' },
            });
          }}
        >
          Get Started - Find a Repair Facility
        </Button>
      </ButtonRow>
    </ModalContentWrapper>
  );
};

export default MechanicalSubmission;
